import { Button } from '@e2n/ui';
import { useDeleteArbeitszeitVerknuepfung } from '@/domain/termine/hooks/useDeleteArbeitszeitVerknuepfung';
import { Arbeitszeit } from '@/domain/termine/shared/types/Arbeitszeit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkLarge } from '@fortawesome/pro-regular-svg-icons';
import { useToast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { ArbeitszeitInfo } from '@/domain/termine/features/UpdateTermin/shared/Verknuepfungen';

export function ArbeitszeitVerknuepfungCard({
  arbeitszeit,
  terminId,
}: {
  arbeitszeit: Arbeitszeit;
  terminId: string;
}) {
  const { deleteArbeitszeitVerknuepfung, loading } =
    useDeleteArbeitszeitVerknuepfung();
  const { toast } = useToast();
  const { t } = useTranslation();

  // oxlint-disable-next-line complexity
  async function handleDelete() {
    if (!terminId) {
      Sentry.captureMessage(
        'Fehlende terminId für Arbeitszeit-Verknüpfung entfernen',
        {
          level: 'warning',
          extra: { terminId, arbeitszeitId: arbeitszeit.id },
        },
      );
      toast({
        title: t('domain.termine.verknuepfung.deleteError'),
      });
      return;
    }
    try {
      const result = await deleteArbeitszeitVerknuepfung({
        idTerminDefinition: terminId,
        idArbeitszeiten: [arbeitszeit.id],
      });
      if (result?.result && result.result.success) {
        toast({ title: t('domain.termine.verknuepfung.deleteSuccess') });
      } else {
        toast({
          title: t('domain.termine.verknuepfung.deleteError'),
          description: result?.error?.message,
        });
      }
    } catch (err) {
      Sentry.captureException(err);
      toast({
        title: t('domain.termine.verknuepfung.deleteError'),
        description: err instanceof Error ? err.message : String(err),
      });
    }
  }

  return (
    <div className="flex gap-2 items-center justify-between w-full p-3 border border-neutrals-300 rounded-lg">
      <ArbeitszeitInfo arbeitszeit={arbeitszeit} />
      <Button
        type="button"
        aria-label={t('domain.termine.form.verknuepfungEntfernen')}
        title={t('domain.termine.form.verknuepfungEntfernen')}
        variant="ghost"
        size="icon"
        disabled={loading}
        onClick={handleDelete}>
        <FontAwesomeIcon icon={faXmarkLarge} />
      </Button>
    </div>
  );
}
